<template>
  <video controls preload="lazy" :poster="previewUrl" class="object-cover">
    <source :src="proxyUrl" type="video/mp4" />
    Your browser does not support the video tag.
  </video>
</template>

<script setup lang="ts">
// TODO:  Fix playing of uploaded videos, they can be proxies on cloudinary like this: https://res.cloudinary.com/djurensratt/video/fetch/https://cms.djurensratt.se/sites/default/files/2024-03/hur-ar-det-att-vara-volontar-hos-djurens-ratt_.mp4
import { useRuntimeConfig } from '#imports'
import { computed } from 'vue'

const { cmsBasePath, cloudname } = useRuntimeConfig().public

const props = defineProps({
  url: String,
})

const proxyUrl = computed(() => {
  return `https://res.cloudinary.com/${cloudname}/video/fetch/${cmsBasePath + props.url}` || ''
})

const previewUrl = computed(() => {
  return (
    `https://res.cloudinary.com/${cloudname}/video/fetch/e_preview,f_png/${cmsBasePath + props.url}` ||
    ''
  )
})
</script>
